import { useQuery } from "@tanstack/react-query";
import adminApi from "../../api/adminApi";

export const useGetAllSubject = () => {
    return useQuery({
        queryKey: ["subjects"],
        queryFn: async () => {
            const res = await adminApi.getAllSubject();
            return res.data; // 👈 trả về res.data thay vì cả response
        },
    });
};